import { token } from '@cp/shared/di';
import type { IntentStorage, IntentionService } from './service';

export const INTENTION_SERVICE = token<IntentionService>('INTENTION_SERVICE');
export const INTENTION_STORAGE = token<IntentStorage>('INTENTION_STORAGE');
